import { Box, Stack, Steps, Text } from 'shell/components';

const StepsDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Steps</Text>
            <Box sx={{ maxWidth: '400px' }}>
                <Steps
                    steps={[
                        {
                            completed: false,
                            disabled: true,
                            element: (
                                <Stack spacing={2}>
                                    <Stack alignItems={'center'} direction={'row'} spacing={2}>
                                        <Text variant={'sh2'} weight={'semibold'}>
                                            Preview and Fine-Tune
                                        </Text>
                                        <Text component={'i'} color={'light'}>
                                            Recommended
                                        </Text>
                                    </Stack>
                                    <Text color={'light'}>
                                        Upload up to three sample submissions to preview grading and feedback, and make
                                        adjustments to align with your criteria. For best results, include high, medium,
                                        and low-scoring examples. Fine-tuning is optional but highly recommended for
                                        better accuracy.
                                    </Text>
                                </Stack>
                            ),
                        },
                        {
                            completed: false,
                            element: (
                                <Text variant={'sh2'} weight={'semibold'}>
                                    Final Submission Grading and Feedback
                                </Text>
                            ),
                        },
                    ]}
                />
            </Box>
        </>
    );
};

export default StepsDemo;
